import { BackendError } from './base';
import general from './general';

class AccountDoesNotExist extends BackendError {}
class AccountPhoneCannotBeUpdated extends BackendError {}
class AdminAccountDoesNotExist extends general.NotFound {}
class CPFAlreadyRegistered extends BackendError {}
class CouldNotIssueVerificationCode extends BackendError {}
class CouldNotUseReferralInExistingAccount extends BackendError {}
class EmailAlreadyRegistered extends BackendError {}
class EmailAlreadyVerified extends BackendError {}
class EmailOrPhoneAlreadyRegistered extends BackendError {}
class Forbidden extends BackendError {}
class GoogleAccountEmailNotVerified extends BackendError {}
class InvalidAccountVerificationCode extends BackendError {}
class InvalidAuthenticationToken extends BackendError {}
class InvalidEmailAddress extends BackendError {}
class InvalidGoogleIdToken extends BackendError {}
class InvalidGoogleLoginEmail extends BackendError {}
class InvalidMfaToken extends BackendError {}
class InvalidMfaCode extends BackendError {}
class InvalidPasswordResetToken extends BackendError {}
class InvalidSession extends BackendError {}
class InvalidToken extends BackendError {}
class NoAccountVerificationRequest extends general.NotFound {}
class OldPasswordIsIncorrect extends BackendError {}
class PasswordIsIncorrect extends BackendError {}
class PhoneAlreadyRegistered extends BackendError {}
class PhoneAlreadyVerified extends BackendError {}
class PhoneVerifiedRecently extends BackendError {}
class VerificationAttemptRateLimit extends BackendError {}
class VerificationCodeIssueRateLimit extends BackendError {}

export default {
    AccountDoesNotExist,
    AccountPhoneCannotBeUpdated,
    AdminAccountDoesNotExist,
    CPFAlreadyRegistered,
    CouldNotIssueVerificationCode,
    CouldNotUseReferralInExistingAccount,
    EmailAlreadyRegistered,
    EmailAlreadyVerified,
    EmailOrPhoneAlreadyRegistered,
    Forbidden,
    GoogleAccountEmailNotVerified,
    InvalidAccountVerificationCode,
    InvalidAuthenticationToken,
    InvalidEmailAddress,
    InvalidGoogleIdToken,
    InvalidGoogleLoginEmail,
    InvalidMfaToken,
    InvalidMfaCode,
    InvalidPasswordResetToken,
    InvalidSession,
    InvalidToken,
    NoAccountVerificationRequest,
    OldPasswordIsIncorrect,
    PasswordIsIncorrect,
    PhoneAlreadyRegistered,
    PhoneAlreadyVerified,
    PhoneVerifiedRecently,
    VerificationAttemptRateLimit,
    VerificationCodeIssueRateLimit,
};
